import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { WorkflowLevelAutomationService } from '@features/workflow-automation/services/workflow-level-automation.service';
import { EmployeeSSOFieldsService } from '../employee-sso-fields.service';

export const employeeSSOFieldsConfigurationResolver: ResolveFn<void> = async (
  next: ActivatedRouteSnapshot
) => {
  const workflowLevelAutomationService = inject(WorkflowLevelAutomationService);
  await inject(EmployeeSSOFieldsService).setEmployeeSSOFields();
  if (next.data.isWorkflowAutomation) {
    workflowLevelAutomationService.resetWorkflowObjects(
      next.data.isAdvancement
    );
  }
};
